import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import { Box, BoxProps, styled } from '@project44/manifest-ds';
import { usePortal } from '@project44/ui-utils';

import Overlay from './Overlay';
import { Position } from './utils';

const StyledTooltip = styled(Box);
interface PopupProps extends BoxProps {
  children: JSX.Element[] | JSX.Element;
  title: string;
  description: React.ReactNode;
  position?: Position;
}

export const Popup = ({
  children,
  title,
  description,
  position = 'bottom',
  ...boxProps
}: PopupProps) => {
  const [visible, setVisible] = useState(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const target = usePortal('workspace-popup');

  return (
    <StyledTooltip
      data-testid="workspace-popup"
      onMouseEnter={() => {
        if (!visible) setVisible(true);
      }}
      ref={wrapRef}
      {...boxProps}
      style={{ position: 'relative' }}
    >
      {children}
      {createPortal(
        <Overlay
          onClose={() => setVisible(false)}
          wrapperRef={wrapRef.current}
          position={position}
          title={title}
          description={description}
          visible={visible}
        />,
        target,
      )}
    </StyledTooltip>
  );
};
